import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
//import Table from "components/Table/Table.js";
import CustomButton from "components/CustomButtons/Button"
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import ThermostatIcon from '@mui/icons-material/Thermostat';
import CustomAreaChart from "components/CustomAreaChart/CustomAreaChart";
import Swal from 'sweetalert2';

import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import BoltIcon from '@mui/icons-material/Bolt';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import CustomLineChartNPK from "components/CustomLineChart/CustomLineChartNPK";

import Select from 'react-select';
//import {RangePicker} from 'react-minimal-datetime-range';
import 'react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css';

import { useSelector } from 'react-redux';
import { useState, useEffect} from "react";
import { useDispatch } from 'react-redux';
import { dataActions } from '../../store/data-slice'


import { fetchConToken } from "helpers/fetch";
import { getSensors, getSensorsStr, mapSensorsList, mapSelectedSensorsStr, transformDateRange } from "helpers/sensors";
import { MultiSelect } from "components/MultiSelect/MultiSelect";


import { DatePicker } from 'antd';



import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import "react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css";
import 'antd/dist/antd.css';
import moment from 'moment';

import './styles.css';

import { setDateHistoricos } from '../../store/data-actions';



/* const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}; */

const useStyles = makeStyles(styles);



const now = new Date();
/* const todayY = now.getFullYear();
const todayM = now.getMonth() + 1;
const todayD = now.getDate(); */


const { RangePicker } = DatePicker;




const translations = {
  en: {
    lSoilTemp: "Soil Temp.",
    lSoilMoist: "Soil Moist.",
    lPh: "PH",
    lEc: "Electrical Conductivity",
    lNPK: "NPK",
    lBattery: "Battery",
    lSoilTempCard: "Soil Temperature:",
    lSoilMoistCard: "Soil Moisture:",
    lPhCard: "Soil PH:",
    lEcCard: "Soil Electrical Conductivity:",
    lNPKCard: "NPK",
    lNPKCard2: "Nitrogen, Phoshorus, Potasium mg/kg:",
    lBatteryCard: "Battery Load:",
    lError: "Fetching metrics error",
    lLastDay: "Last Day",
    lLastWeek: "Last Week",
    lLastMonth: "Last Month",
    lSensors: "Sensors",
    lRange: "Time Range:",
    lMetrics: "Metrics:",
    lApply: "Apply",
  },
  es: {
    lSoilTemp: "Temperatura Suelo",
    lSoilMoist: "Humedad Suelo",
    lPh: "PH",
    lEc: "Conductividad Eléctrica",
    lNPK: "NPK",
    lBattery: "Batería",
    lSoilTempCard: "Temperatura del Suelo:",
    lSoilMoistCard: "Humedad del Suelo:",
    lPhCard: "PH del Suelo:",
    lEcCard: "Conductividad Eléctrica del Suelo:",
    lNPKCard: "NPK",
    lNPKCard2: "Nitrógeno, Fósforo, Potasio mg/kg:",
    lBatteryCard: "Carga de Batería:",
    lError: "Error Carga de métricas",
    lLastDay: "Último Dia]",
    lLastWeek: "Últma Semana",
    lLastMonth: "Último Mes",
    lSensors: "Sensores:",
    lRange: "Rango de Tiempo:",
    lMetrics: "Métricas:",
    lApply: "Aplicar",
    
  }
};

export default function Historicos() {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const {language} = useSelector( state => state.data); 
  const t = translations[language];

  const metricas_options = [
    { value: "mean_soil_temp", label: t.lSoilTemp },
    { value: "mean_soil_moist", label: t.lSoilMoist },
    { value: "mean_ph", label: t.lPh },
    { value: "mean_ec", label: t.lEc },
    { value: "npk_over_time", label: t.lNPK },
    { value: "mean_voltage", label: t.lBattery }
  ];

  // const [selectedMetricasOption, setSelectedMetricasOption] = useState(null);
  const [selectedMetricas, setSelectedMetricas] = useState([]);
  const [selectedSensors, setSelectedSensors] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(["-12h","now()"]);
  const [loading, setLoading] = useState(true);
  const [selectedSensorsStr, setSelectedSensorsStr] = useState("");

  const { checking } = useSelector( state => state.auth);
  const { allPlantaciones, indexPlantacion, plantaciones, listaSensoresHistoricos, selectedSensorsMulti, selectedMetricasMulti, startDate, endDate } = useSelector( state => state.data);
  
  //let [sensors, setSensors] = useState(["65d993f557cacc29"]);

  //let sensors = ["65d993f557cacc29"]; //moved to MapSensor List
  let sensors = getSensors(plantaciones, allPlantaciones, indexPlantacion);
  let sensorStr = getSensorsStr(sensors);
  

  //setSelectedSensorsStr(sensorStr);
  
  
  //const { start, query, sensors, fillcolor, strokecolor } = props;

  let [voltage_average, setVoltageAverage] = useState("");
  let [ec_average, setEcAverage] = useState("");
  let [ph_average, setPhAverage] = useState("");
  let [N_average, setNAverage] = useState("");
  let [P_average, setPAverage] = useState("");
  let [K_average, setKAverage] = useState("");
  let [soil_temp_average, setSoilTempAverage] = useState("");
  let [soil_moist_average, setSoilMoistAverage] = useState("");
  //let [data2, setData2] = useState([]);

 /*  const [hour, setHour] = useState(String(now.getHours()));
  const [minute, setMinute] = useState(String(now.getMinutes() + 1).padStart(2, '0'));
  const [month, setMonth] = useState(String(now.getMonth() + 1).padStart(2, '0'));
  const [date, setDate] = useState(String(now.getDate()).padStart(2, '0'));
  const [year, setYear] = useState(String(now.getFullYear())); */


  const query = "all_average";
  //const startDate = "2022-10-20T08:20:55Z";
  //const stopDate = "2022-10-23T20:20:55Z";

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    sensors = [];
    sensors = getSensors(plantaciones, allPlantaciones, indexPlantacion);
    sensorStr = getSensorsStr(sensors);
  
  
    //inicia con todos los sensores seleccionados, averiguar como hacer el multiselect que escoga todos delsde el inicio
    setSelectedSensorsStr(sensorStr);
    setSelectedSensors(sensors);
    setSelectedMetricas(metricas_options);

    console.log('SensorList:', JSON.stringify(mapSensorsList(plantaciones, allPlantaciones, indexPlantacion)) );


    dispatch(dataActions.sensoresHistoricos({
      listaSensoresHistoricos: mapSensorsList(plantaciones, allPlantaciones, indexPlantacion),
    }))

    //inicia con todas la metricas seleccionados, averiguar como hacer el multiselect que escoga todos delsde el inicio
    dispatch(dataActions.filtrosMetricasHistoricos({
      selectedMetricasMulti: metricas_options,
    }))
    dispatch(dataActions.filtrosSensoresHistoricos({
      selectedSensorsMulti: selectedSensors,
    }))


    //query all averages for each card near real-time measure
    
    
   //console.log("SensorStr in useEffect Hist:" + sensorStr);
   
   
   const fetchData = async () => {
      try {
        const resp = await fetchConToken( `data?start=`+startDate+`&stop=`+endDate+`&query=`+query+ `&sensors=`+sensorStr )
        const body = await resp.json();
        
        //console.log("dataAverage:" + body);
        
        if( body.ok ) {
            if(mounted) {
              //setAverages(body.data)
              
              let int_averages = body.data.map((entry)=>{
                //console.log("Measurement in item averages:",entry.measurement);
                switch ( entry.measurement ) {
                  case "device_frmpayload_data_voltage":
                    return {measure: "voltage", value: entry.value }
                  case "device_frmpayload_data_ph":
                    return {measure: "ph", value: entry.value }
                  case "device_frmpayload_data_ec":
                    return {measure: "ec", value: entry.value }
                  case "device_frmpayload_data_N":
                    return {measure: "n", value: entry.value }
                  case "device_frmpayload_data_P":
                    return {measure: "p", value: entry.value }
                  case "device_frmpayload_data_K":
                    return {measure: "k", value: entry.value }
                  case "device_frmpayload_data_soil_temp":
                    return {measure: "soil_temp", value: entry.value }
                  case "device_frmpayload_data_soil_moist":
                    return {measure: "soil_moist", value: entry.value }
                  default:
                    return {measure: "voltage", value: entry.value }
                }
                
                
              }) 
              //setAverages(int_averages);
              //console.log("found volt:"+int_averages.find(item => item.measure === "voltage"));
              //console.log("found ec:"+int_averages.find(item => item.measure === "ec"));
              //console.log("found altitude:"+int_averages.find(item => item.measure === "altitude"));
              

              let voltageAverage = "No data";
              (int_averages.find(item => item.measure === "voltage")) && (voltageAverage = ''+(int_averages.find(item => item.measure === "voltage").value).toFixed(1));
              setVoltageAverage(voltageAverage);

              let ecAverage = "No data";
              (int_averages.find(item => item.measure === "ec")) && (ecAverage = ''+(int_averages.find(item => item.measure === "ec").value).toFixed(0));
              setEcAverage(ecAverage);

              let phAverage = "No data";
              (int_averages.find(item => item.measure === "ph")) && ( phAverage = ''+(int_averages.find(item => item.measure === "ph").value/100).toFixed(1));
              setPhAverage(phAverage);

              let NAverage = "No data";
              (int_averages.find(item => item.measure === "n")) && ( NAverage = ''+(int_averages.find(item => item.measure === "n").value).toFixed(1));
              setNAverage(NAverage);

              let PAverage = "No data";
              (int_averages.find(item => item.measure === "p")) && ( PAverage = ''+(int_averages.find(item => item.measure === "p").value).toFixed(1));
              setPAverage(PAverage);

              let KAverage = "No data";
              (int_averages.find(item => item.measure === "k")) && ( KAverage = ''+(int_averages.find(item => item.measure === "k").value).toFixed(1));
              setKAverage(KAverage);

              let SoilTempAverage = "No data";
              (int_averages.find(item => item.measure === "soil_temp")) && ( SoilTempAverage = ''+(int_averages.find(item => item.measure === "soil_temp").value/1).toFixed(1));
              setSoilTempAverage(SoilTempAverage);
              
              let SoilMoistAverage = "No data";
              (int_averages.find(item => item.measure === "soil_moist")) && ( SoilMoistAverage = ''+(int_averages.find(item => item.measure === "soil_moist").value/1).toFixed(1));
              setSoilMoistAverage(SoilMoistAverage);
             

              //console.log(''+(averages.find(item => item.measure === "voltage").value).toFixed(2));
              //setData2(modifiedDate);

            }
        }else{
          Swal.fire('Error code:H0x003', t.lError, 'error');
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        Swal.fire('Error code:H0x004', t.lError, 'error');
      }
      
    }
    fetchData();
    
    

    return () => mounted = false;
  }, [indexPlantacion, allPlantaciones, ])

  if ( loading ) {
     
    return (
        <div style={{padding: '10px', width: '80px', height: '80px'}}>
            <LoadingSpinner />
        </div>
        );
  }
  
  const handleChangeDate = (dates, dateStrings) => {
    if (dates) {
      console.log('From: ', dates[0], ', to: ', dates[1]);
      console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
     
      
      setSelectedDateRange(transformDateRange(dates));

      //dispatch(setDateHistoricos(value))

    } else {
      console.log('Clear');
    }
  };
  
  const handleOkDate = (value) => {
    //console.log('onOk: ', value);

    setSelectedDateRange(value);

    //dispatch(setDateHistoricos(value))
  };


  const handleChangeMetricas = (e) => {
    setSelectedMetricas(e);
    console.log("selected metricas:", e);
    
    /* dispatch(dataActions.filtrosMetricasHistoricos({
      selectedMetricasMulti: e,
    })) */
    
      //Array.isArray(e) ? e.map(x => x.value) : []);
  }

  const handleChangeSensors = (e) => {
    setSelectedSensors(e);
    console.log("selected sensors to CAC HandlerChange:", mapSelectedSensorsStr(e));
    

    setSelectedSensorsStr(mapSelectedSensorsStr(selectedSensors));
    //setSelectedSensorsStr(mapSelectedSensorsStr(e));

    /* dispatch(dataActions.filtrosSensoresHistoricos({
      selectedSensorsMulti: e,
    })) */
      //Array.isArray(e) ? e.map(x => x.value) : []);
  }
  
  const handleApply = (e) => {
    
    console.log("Cicked APPLY:", e);
    console.log("Selected Sensors before APPLY :", selectedSensors);
    if (selectedSensors[0]=="undefined"){   //si es primera vez o no se escoge nada en listado de sensores
      //setSelectedSensorsStr(mapSelectedSensorsStr(selectedSensors));
      console.log("sent selected sensors from APPLY no SELECTION:", selectedSensorsStr);
    }else{
      setSelectedSensorsStr(mapSelectedSensorsStr(selectedSensors));
    }
    

    console.log("sent selected sensors from APPLY:", selectedSensorsStr);
    /* dispatch(dataActions.filtrosMetricasHistoricos({
      selectedMetricasMulti: selectedMetricas,
    }))
    dispatch(dataActions.filtrosSensoresHistoricos({
      selectedSensorsMulti: mapSelectedSensorsStr(selectedSensors),
    }))
    //dispatch(setDateHistoricos(value))
    
    dispatch(dataActions.filtrosDateHistoricos({
      startDate: selectedDateRange[0],
      endDate: selectedDateRange[1],
    })) */



     dispatch(dataActions.filtrosHistoricos({
      selectedMetricasMulti: selectedMetricas,
      selectedSensorsMulti: selectedSensors,
      startDate: selectedDateRange[0],
      endDate: selectedDateRange[1],
    })) 
  }
  

  
  return (
    <>
      <div style={{display: "flex", justifyContent: 'flex-start', alignItems: 'center' ,flexDirection: 'row', width: '100%', padding: '1px', flexWrap:'wrap'}}>
        <div style={{display: "flex", justifyContent: 'flex-start', alignItems: 'center' ,flexDirection: 'row', padding: '1px', marginLeft: '5px', marginBottom: '1px', flexWrap:'wrap'}}>
          <div className="filtersTitle"> {t.lRange} </div>
          <RangePicker
                    ranges={{
                      [t.lLastDay]: [moment().subtract(24, 'hours'), moment()],
                      [t.lLastWeek]: [moment().subtract(7, 'days'), moment()],
                      [t.lLastMonth]: [moment().subtract(1,'month'), moment()],
                    }}
                    showTime={{
                      format: 'HH:mm',
                    }}
                    format="YYYY/MM/DD HH:mm"
                    size="medium"
                    
                    // onOk={handleOkDate}
                    onChange={handleChangeDate}
                    placement='topLeft'
                  />
          
        </div>
        <div style={{display: "flex", justifyContent: 'flex-start', alignItems: 'center' ,flexDirection: 'row', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
          <div className="filtersTitle"> {t.lMetrics} </div>
          <div style={{marginBottom: '1px', marginLeft: '10px'}}>
              <div style={{zIndex: '1000', maxWidth:'300px', minWidth:'200px'}}>
                  <MultiSelect options={metricas_options} value={selectedMetricas} onChange={handleChangeMetricas} />
              </div>
          </div>
        </div>
        <div style={{display: "flex", justifyContent: 'flex-start', alignItems: 'center' ,flexDirection: 'row', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
          <div className="filtersTitle"> {t.lSensors} </div>
          <div style={{marginBottom: '1px', marginLeft: '10px'}}>
              <div style={{zIndex: '1000', maxWidth:'300px', minWidth:'200px'}}>
                  <MultiSelect options={listaSensoresHistoricos} value={selectedSensors} onChange={handleChangeSensors} />
              </div>
          </div>
        </div>
        
        <div style={{display: "flex", justifyContent: 'flex-start', alignItems: 'center' ,flexDirection: 'row', padding: '1px', marginLeft: '10px', marginBottom: '5px'}}>
          <div className="filtersTitle"> 
            <CustomButton color="green" round={true} size='sm' onClick={handleApply}> 
              {t.lApply} 
            </CustomButton>
          </div> 
          
        </div>
      </div>
      
      
      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
             
          <Card chart>
            <CardHeader color="green">
            
            </CardHeader>
          
            {/* <CardFooter chart>
              <div className={classes.stats}>
              <AccessTime /> OpenWeather API
              </div>
            </CardFooter> */}
          </Card>

        </GridItem>
        </GridContainer>
    
    
    <GridContainer>


    



      { selectedMetricasMulti.find((element) => {
        return element.value === "mean_soil_temp";
        }) &&  (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
            <CardHeader color="warning" stats icon>
                  <CardIcon color="warning">
                    <ThermostatIcon />
                    {/* <Icon>content_copy</Icon> */}
                    {/* <Icon baseClassName="fas" className="fa-solid fa-temperature-high" /> */}
                    {/* <FontAwesomeIcon icon="fa-solid fa-temperature-high" /> */}
    
                  </CardIcon>
                  <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lSoilTempCard}  &nbsp; </p>
                  {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {soil_temp_average} <small>°C</small> 
                  </h2> */}
              </CardHeader>
          
              <CardBody style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'200px'}}>
                {/* <ThermostatIcon />
                <p className={classes.cardCategory} style={{fontSize: '21px', display:'inline'}}>Temperatura del Suelo : &nbsp; </p>
                <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {soil_temp_average} <small>°C</small> 
                </h2> */}
                <CustomAreaChart start={startDate} stop={endDate} query="mean_soil_temp" sensors={selectedSensorsStr} strokecolor='#DD7B13' fillcolor='#FE952D' units='°C' factor={1} />
              </CardBody>
              
              {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                  
              </CardFooter> */}
    
            </Card>
          </GridItem>

        )}

      



      { selectedMetricasMulti.find((element) => {
          return element.value === "mean_soil_moist";
          }) &&  (

        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success" stats icon>
                <CardIcon color="success">
                
                  <LocalDrinkIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lSoilMoistCard} &nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {soil_moist_average} <small>%</small> 
                </h2> */}
            </CardHeader>
        
            <CardBody  style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'200px'}}>
              <CustomAreaChart key={selectedSensorsStr} start={startDate} stop={endDate} query="mean_soil_moist" sensors={selectedSensorsStr} strokecolor='#29B24F' fillcolor='#2FD15C' units='%' factor={1} />
          </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      )}

      { selectedMetricasMulti.find((element) => {
          return element.value === "mean_ph";
          }) &&  (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <AutoGraphIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lPhCard} &nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ph_average} 
                </h2> */}
            </CardHeader>
        
            <CardBody  style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'200px'}}>
              <CustomAreaChart start={startDate} stop={endDate} query="mean_ph" sensors={selectedSensorsStr} strokecolor='#AF1F1F' fillcolor='#E02D2D' units='pH' factor={100} />
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      )}

      { selectedMetricasMulti.find((element) => {
          return element.value === "mean_ec";
          }) &&  (

        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <BoltIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lEcCard} &nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ec_average} <small>mS/m</small>
                </h2> */}
              </CardHeader>
        
            <CardBody  style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'200px'}}>
              <CustomAreaChart start={startDate} stop={endDate} query="mean_ec" sensors={selectedSensorsStr} strokecolor='#1A759F' fillcolor='#2C95C5' units='mS/m' factor={1} />
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      )}
      
      { selectedMetricasMulti.find((element) => {
          return element.value === "npk_over_time";
          }) &&  (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="primary" stats icon>
              <CardIcon color="info">
              <h2 className={classes.cardTitle} style={{fontSize: '20px', fontWeight: '600', color: 'white'}}> {t.lNPKCard} </h2>
              </CardIcon>
                {/* <p className={classes.cardCategory}>NPK</p>
                <p></p> */}
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}} >{t.lNPKCard2} &nbsp;</p>

                
                {/* <h4 style={{display: "inline", color: "#8884d8", fontSize: '25px',}}> 
                  N: &nbsp;
                </h4>
                <h4 style={{display: "inline", color: "#8884d8", fontSize: '22px',}}> 
                  {N_average},  &nbsp;
                </h4>

                <h4 style={{display: "inline", color: "#82ca9d", fontSize: '25px',}}> 
                  P: &nbsp;
                </h4>
                <h4 style={{display: "inline", color: "#82ca9d", fontSize: '22px',}}> 
                  {P_average}, &nbsp; 
                </h4>

                <h4 style={{display: "inline", color: "#85cafd", fontSize: '25px',}}> 
                  K:&nbsp;
                </h4>
                <h4 style={{display: "inline", color: "#85cafd", fontSize: '22px',}}> 
                  {K_average} &nbsp;
                </h4> */}
                
                

                

                
              </CardHeader>
        
            <CardBody  style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'200px'}}>
              <CustomLineChartNPK start={startDate} stop={endDate} query="npk_over_time" sensors={selectedSensorsStr} />
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      )}


      { selectedMetricasMulti.find((element) => {
          return element.value === "mean_voltage";
          }) &&  (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <BoltIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', display:'inline'}}>{t.lBatteryCard} &nbsp;</p>
              {/*   <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                {voltage_average} <small>V.</small>
                </h2> */}
              </CardHeader>
        
            <CardBody  style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'200px'}}>
              <CustomAreaChart start={startDate} stop={endDate} query="mean_voltage" sensors={selectedSensorsStr} strokecolor='#1A759F' fillcolor='#2C95C5' units='V' factor={1} />
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      )}

    </GridContainer>
  </>
  );
}
